module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e304"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hunt_9781595542595_epub_c6.1_r1#d12e164",
      "id": "d12e305"
    }
  }, [_vm._v("one")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595542595_0008_002",
      "id": "d12e307",
      "src": "images/9781595542595_0008_002.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e308"
    }
  }, [_c('b', [_c('i', [_vm._v("J")])]), _vm._v("osephine Mitchell was up to her wrists in dirt when she heard the whistle. She looked past the ornamental iron railing down to street level where Cody Something shut the door of his ’79 Mustang.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e313"
    }
  }, [_vm._v("He approached her veranda, shading his eyes from the sun with his hand. “Hey, Apartment 2B, my friend came through.”\n Cody tugged two tickets from the back pocket of his khaki shorts. “Louisville versus UK.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e315"
    }
  }, [_vm._v("Josie pulled her hands from under the wisteria’s roots and patted the dirt down. “Answer’s still no.” She smiled to soften the rejection, then poured more of the sandy loam around the vine’s woody roots.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e317"
    }
  }, [_vm._v("“Forty-yard line. Biggest game of the year . . .” A shadow puddled in his dimple.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e319"
    }
  }, [_vm._v("“Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e321"
    }
  }, [_vm._v("He sighed. “When are you going to break down and say yes?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e323"
    }
  }, [_vm._v("Josie’s cell phone pealed and vibrated simultaneously in her pocket. “Saved by the bell.” She wiped her hands on her jeans and checked the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e325"
    }
  }, [_vm._v("A frown pulled her brows. Her sister hadn’t called since she’d gotten the big news four months ago. Josie hoped she was okay.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e327"
    }
  }, [_vm._v("“Sorry, gotta take this,” she told Cody, then flipped open the phone. “Hey, Laurel.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e330"
    }
  }, [_vm._v("There was a pause at the other end. “Josie? It’s Nate. Your brother-in-law.” As if Josie didn’t know his name or voice. He’d only dated her sister four years before finally proposing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e332"
    }
  }, [_vm._v("But Nate had never called Josie, and the fact that he was now only reinforced her previous suspicion. “Is everything okay? Laurel and the baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e334"
    }
  }, [_vm._v("“They’re fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e336"
    }
  }, [_c('i', [_vm._v("Thank God. ")]), _vm._v("Laurel and Nate had wanted a baby for so long. They’d been ready to start trying, but then Laurel and Josie’s dad had the stroke, and the newlyweds had to move in with him and take care of him and the family orchard. Laurel hadn’t had the time or energy for a baby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e340"
    }
  }, [_vm._v("Josie sat back on her haunches and wiped her hair from her eyes with a semiclean finger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e342"
    }
  }, [_vm._v("“I’m calling about the orchard.” Nate’s tone was short and clipped. “I think it’s high time you hauled your city-slicker fanny back here to help your sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e344"
    }
  }, [_vm._v("She almost thought he was joking—Nate was as easygoing as they came, and she’d never heard him sound so adamant or abrupt. But there was no laughter on the other end of the line.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e346"
    }
  }, [_vm._v("Words stuck in Josie’s throat. She swallowed hard. “I don’t understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e348"
    }
  }, [_vm._v("“No, you don’t. "), _c('i', [_vm._v("Responsibility ")]), _vm._v("is a foreign word to you. I get that. But there comes a time when a person has to step up to the plate and—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e353"
    }
  }, [_vm._v("“Wait a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e355"
    }
  }, [_vm._v(" “—help when they’re needed. And Laurel needs your help. We can’t afford to hire anyone else, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e358"
    }
  }, [_vm._v("This didn’t sound like Nate. True, she hadn’t talked to him in ages, but he’d always been the picture of Southern hospitality.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e360"
    }
  }, [_vm._v("Below the veranda, Cody caught her eye and waved the tickets temptingly. When she shook her head no, his lips turned down in an exaggerated pout, his chin fell dramatically to his chest, and he sulked toward the apartment’s main door. But not before he turned and flashed his dimple one more time, just to let her know he wasn’t too heartbroken. They both knew he was already mentally sorting through the other candidates in his little black book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e362"
    }
  }, [_vm._v("Nate’s angry voice pulled her back to the conversation, which, she realized belatedly, had been silent on her end for too long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e364"
    }
  }, [_vm._v("“I don’t know why I thought you’d care,” he muttered. She could barely hear his words over the roar of a passing motorcycle. “You didn’t bother coming after the stroke, or for the funeral, why would you care about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e366"
    }
  }, [_vm._v("“What "), _c('i', [_vm._v("this")]), _vm._v("? Would you please tell me what’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e371"
    }
  }, [_vm._v("His breaths were harsh, as if he expected a fight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e373"
    }
  }, [_vm._v("“Laurel is having twins. She just found out yesterday at the ultrasound.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e375"
    }
  }, [_c('i', [_vm._v("Twins. ")]), _vm._v("The word brought back a cluster of memories, none of them good"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e381"
    }
  }, [_vm._v("But Laurel was undoubtedly thrilled. Josie was surprised she hadn’t called, but then again, they hadn’t spoken much since the funeral almost a year ago. “Well, that’s great news.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e383"
    }
  }, [_vm._v("“The doctor wants her to take it easy. And you know Laurel.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e385"
    }
  }, [_vm._v("With harvest just around the bend, there wasn’t much that was easy about working an apple orchard this time of year. The phone call was making sense now. All except Nate’s antagonism. But then he’d always been protective of Laurel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e388"
    }
  }, [_vm._v("“When I came home from work today, I found her painting the nursery, and yesterday she spent the afternoon packing apples in cold storage for a new vendor she got. Every time I turn around, she’s sneaking off to work somewhere, usually the orchard because she’s so worried about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e390"
    }
  }, [_vm._v("Josie stood, stretching her legs, then leaned her elbows on the railing. “She’s never been one to be idle.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e392"
    }
  }, [_vm._v("“She really wants these babies, Josephine. We both do. And after what happened with your mom . . .” His voice wobbled as the sentence trailed off, pinching something inside her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e394"
    }
  }, [_vm._v("“Of course, I completely get that.” It was all sinking in now. She knew why he’d called. And she knew she wouldn’t say no, because, despite the distance between them, she loved her sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e396"
    }
  }, [_vm._v("“She needs help, that’s the bottom line. I don’t need to tell you how much work is involved this time of year, and she can’t do it. We can hardly afford to hire more help.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e398"
    }
  }, [_vm._v("“No, she can’t work the harvest,” Josie agreed. His words from a moment ago replayed in her head like a delayed tape. “You said you can’t hire someone.” Laurel hadn’t mentioned financial troubles. She talked about their manager, Grady, as if he were God’s gift to apples.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e400"
    }
  }, [_vm._v("“Not after last year’s failure.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e402"
    }
  }, [_vm._v("“Failure?” Her sister hadn’t said anything of the kind. True, they didn’t speak often, but when the topic of the orchard did come up, Laurel said everything was fine. At least, Josie thought she had.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e404"
    }
  }, [_vm._v("“Laurel didn’t tell you? There was an Easter frost. We lost the apples.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e406"
    }
  }, [_vm._v("“Frost?” An orchard could lose a whole crop to frost, though this was the first time it had happened at Blue Ridge. Why hadn’t Laurel said something?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e408"
    }
  }, [_vm._v("Nate sighed. “I’m sorry. I thought she told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e411"
    }
  }, [_vm._v("What else had her sister omitted? Laurel was always trying to protect her. Josie should’ve inquired more directly. “How bad is it?” The fragrance from her lavender plant wafted by on a breeze, and Josie closed her eyes, inhaled the calming scent, letting it fill her up, soothe her frayed nerves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e413"
    }
  }, [_vm._v("“The place is a money pit. We don’t have anything else to put into it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e415"
    }
  }, [_c('i', [_vm._v("This changes everything, Josie. Do you realize that?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e418"
    }
  }, [_vm._v("The selfish thought materialized before she could stop it. Her plans . . . How could she follow through now? When Laurel was overburdened with a failing orchard and pregnant with twins?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e420"
    }
  }, [_vm._v("Nate was speaking again. “Grady insists he can turn the place around, but I’m wondering if we shouldn’t sell it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e422"
    }
  }, [_vm._v("She and Laurel were the third generation to own the orchard, and as far as Josie knew, not one of the Mitchells had thought those words, much less said them. And she’d thought Laurel would be the last one to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e424"
    }
  }, [_vm._v("“Laurel’s considering that?” Their father’s death had left Josie with shares that tied her to the place. Even three hundred and fifty miles away, it dragged behind her wherever she went, weighing her down like an anchor. But if Laurel was considering a sale . . .")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e426"
    }
  }, [_vm._v("Now that she’d slipped the thought on for size, it was starting to feel more comfortable, like her favorite pair of Levi’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e428"
    }
  }, [_vm._v("“I haven’t exactly broached the topic,” Nate said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e430"
    }
  }, [_vm._v("That was precisely what needed to happen. It was something her father should’ve done long ago, before he’d saddled Laurel\n with his own care and the care of the orchard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e432"
    }
  }, [_vm._v("“How does this year’s crop look?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e435"
    }
  }, [_vm._v("“Promising. She was hoping this year would put us in the black. But a strong crop means extra work and plenty of hands on deck. And I can’t afford time off.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e437"
    }
  }, [_vm._v("Nate ran Shelbyville’s one and only insurance agency. Good thing they’d had his income to fall back on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e439"
    }
  }, [_vm._v("“So can you come back and help us through the harvest?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e441"
    }
  }, [_vm._v("Josie’s eyes flitted over the lacy white alyssum, past the potted strawberry plant toward the haven of her darkened apartment. She closed her eyes and was, in an instant, back at Blue Ridge Orchard. She could almost smell the apples ripening on the trees. Hear the snap of the branch as an apple twisted free. See the ripples of Sweetwater Creek running alongside the property.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e443"
    }
  }, [_vm._v("And with that thought, the other memories came. The ones that had chased her from Shelbyville six years ago. The ones that still chased her every day. The ones that, at the mention of going home, caused a dread, deep and thick in her belly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e445"
    }
  }, [_vm._v("“Josie, you there?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e447"
    }
  }, [_vm._v("She opened her eyes, swallowing hard. “I’m here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e449"
    }
  }, [_vm._v("“I know you’ve got your photography job and your plans and your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e451"
    }
  }, [_vm._v("She breathed a wry laugh. Ironically, none of that mattered. The one plan that did matter could still play out. Same tune, different venue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e453"
    }
  }, [_vm._v("What mattered most now was seeing that Laurel’s life was settled. And Laurel’s life wouldn’t be settled until she was out from under the orchard. Josie saw that clearly now. And it wouldn’t happen, she knew, without a lot of coaxing. She only hoped there was enough time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e455"
    }
  }, [_vm._v("“I wouldn’t have called if we weren’t desperate.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e458"
    }
  }, [_vm._v("Josie took one last deep breath of the lavender, shoved down the dread, and forced the words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e460"
    }
  }, [_vm._v("“I’ll come.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1a5b98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hunt_9781595542595_epub_c7_r1.vue
// module id = 75
// module chunks = 0